import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-discard-dialog',
  templateUrl: './delete-discard-dialog.component.html',
  styleUrls: ['./delete-discard-dialog.component.scss']
})
export class DeleteDiscardDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DeleteDiscardDialogComponent>,
  ) { }

  ngOnInit(): void {
    
  }

  onProceed(){
    this.dialogRef.close(true);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
